import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { CalendarEventsFilters } from './CalendarEventsFilters';
import { isFeatureEnabled } from 'owa-feature-flags';

function applyFilter(filter: string | CalendarEventsFilters, calendarEvent: CalendarEvent) {
    switch (filter) {
        case CalendarEventsFilters.All:
            return true;
        case CalendarEventsFilters.Appointments:
            return !calendarEvent.IsMeeting;

        case CalendarEventsFilters.Accepted:
            return calendarEvent.ResponseType == 'Accept';

        case CalendarEventsFilters.Organizer:
            return calendarEvent.IsMeeting && calendarEvent.IsOrganizer;

        case CalendarEventsFilters.Attendee:
            return calendarEvent.IsMeeting && !calendarEvent.IsOrganizer;

        default:
            return calendarEvent.Categories != null
                ? calendarEvent.Categories.includes(filter)
                : false;
    }
}

export function eventFilter(
    calendarEvent: CalendarEvent,
    currentFilters: (CalendarEventsFilters | string)[]
) {
    if (
        !isFeatureEnabled('cal-eventsFilterMenu') ||
        !currentFilters ||
        currentFilters == [CalendarEventsFilters.All]
    ) {
        return true;
    }
    let filters: boolean = false;
    for (let filter of currentFilters) {
        const filterApplication: boolean = applyFilter(filter, calendarEvent);
        filters = filters || filterApplication;
    }
    return filters;
}
